import React from 'react';

import DSHelpCategoriesSection from 'aplazame-design-system/src/components/HelpCategoriesSection/index';

export default function HelpCategoriesSection(props) {
    return <DSHelpCategoriesSection {...props} />;
}
